import { useEffect } from 'react';

export const useExternalLinks = (
  ref: any,
  whiteList: { [key: string]: string } = {
    'files-content__link': 'files-content__link',
  }
) => {
  useEffect(() => {
    const hostname = process.env.REACT_APP_MAP_HOSTNAME
      ? process.env.REACT_APP_MAP_HOSTNAME
      : window.location.hostname;
    const content = ref.current;
    const links: HTMLLinkElement[] = Array.from(content.querySelectorAll('a'));
    if (links.length === 0) {
      return;
    }

    links.forEach(link => {
      if (
        !whiteList[`${link.classList}`] &&
        link.href.indexOf(hostname) === -1 &&
        !link.classList.contains('external-link')
      ) {
        link.classList.add('external-link');
        link.insertAdjacentHTML(
          'beforeend',
          `<svg class="icon-external-link"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><g fill="#A39191"><path d="M13.133 0H8.321a.864.864 0 000 1.725h2.73L6.497 6.28a.857.857 0 00-.253.61c0 .23.09.447.253.61a.858.858 0 001.22 0l4.554-4.554v2.73a.864.864 0 001.725 0V.863A.864.864 0 0013.133 0z"/><path d="M9.915 12.517H1.48V4.081h6.345l1.479-1.479H.739a.74.74 0 00-.739.74v9.915c0 .408.331.74.74.74h9.915a.74.74 0 00.74-.74V4.694l-1.48 1.478v6.345z"/></g></svg>`
        );
      }
    });
  }, [ref, whiteList]);
};
